<template>
  <div v-wechat-title="$route.meta.title">
    <common-header @setLocale="getLocale"></common-header>
    <common-nav :locale="locale"></common-nav>
    <!-- 面包屑导航 -->
    <u-animate-container class="type_breadcrumb">
      <div class="container">
        <u-animate
          class="type"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          {{ list.pcName }}<span>{{ list.pcEnglishName }}</span>
        </u-animate>
        <u-animate
          class="breadcrumb"
          name="fadeInDown"
          delay="0s"
          duration="1s"
          :iteration="1"
          :offset="0"
          animateClass="animated"
          :begin="false"
        >
          <router-link to="/index" tag="span">{{
            $t("menu.index")
          }}</router-link>
          <span>></span>
          <router-link to="/product" tag="span">{{
            $t("menu.product")
          }}</router-link>
          <span>></span>
          <span class="on">{{ list.pcName }}</span>
        </u-animate>
      </div>
    </u-animate-container>
    <!-- 标题块 -->
    <u-animate-container class="title_wrap">
      <div class="bg_wrap">
        <img src="@/assets/images/logo_png.png" class="bg_title" />
      </div>
      <div class="container">
        <img :src="list.verticalImage" alt="" class="product" />
        <div class="title">
          <u-animate
            class="en"
            name="fadeInDown"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            {{ list.pNumber }}
          </u-animate>
          <u-animate
            class="cn"
            name="fadeInDown"
            delay="0.3s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            {{ list.name }}
          </u-animate>
          <u-animate
            class="desc"
            name="fadeInDown"
            delay="0.6s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            {{ list.desc }}
          </u-animate>
        </div>
      </div>
    </u-animate-container>
    <!-- 标题下方描述 -->
    <u-animate-container class="detail_content" v-if="isShowExtraDesc === 1">
      <u-animate
        class="container"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <span class="before">“</span><span>{{ list.extraDesc }}</span
        ><span class="after">”</span>
      </u-animate>
    </u-animate-container>
    <!-- 视频 -->
    <u-animate-container class="detail_video" v-if="isShowVideo === 1">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        v-if="!videoSrc.includes('youtube')"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
      <iframe
        class="video-player vjs-custom-skin"
        v-else
        :src="videoSrc"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </u-animate-container>
    <!-- 特点 -->
    <u-animate-container class="detail_feature" v-if="isShowFeature === 1">
      <common-title
        :cn="$i18n.locale === 'zh-cn' ? '特点' : 'FEATURES'"
      ></common-title>
      <div class="container">
        <img :src="list.feature.image" />
        <div class="content">
          <p v-for="fp in list.feature.feature" :key="fp">{{ fp }}</p>
        </div>
      </div>
    </u-animate-container>
    <!-- 材质 -->
    <u-animate-container class="detail_material" v-if="isShowMaterial === 1">
      <common-title
        :cn="$i18n.locale === 'zh-cn' ? '材质' : 'MATERIAL'"
      ></common-title>
      <u-animate
        class="container"
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <div class="head">
          <div class="img_head"></div>
          <div class="title_head">
            <!-- 材质<span>MATERIAL</span> -->
            {{ $t("product.material.material") }}
          </div>
          <div class="title_head">
            <!-- 表面处理<span>FINISH</span> -->
            {{ $t("product.material.finish") }}
          </div>
        </div>
        <div
          class="item"
          v-for="(m, mi) in list.material"
          :key="mi + m.material"
        >
          <div class="img_item">
            <img src="@/assets/images/icon_maoding1.png" v-if="mi == 0" />
            <img src="@/assets/images/icon_maoding2.png" v-else />
          </div>
          <div class="title_item">
            <p>{{ m.material }}</p>
          </div>
          <div class="title_item">
            <p>{{ m.surface }}</p>
          </div>
        </div>
      </u-animate>
    </u-animate-container>
    <!-- 规格表 -->
    <u-animate-container class="detail_table">
      <common-title
        :cn="$i18n.locale === 'zh-cn' ? '规格表' : 'AVAILABLE SIZES'"
      ></common-title>
      <div class="container">
        <img :src="list.specImage" class="top" />
        <div
          class="table_item"
          :class="i.isClick === 1 ? 'on' : ''"
          v-for="(i, table_index) in list.specList"
          :key="i.diameter"
          @click="toggleTable(table_index)"
        >
          <div class="item">
            <div class="item_index">
              <p>D</p>
              <p style="margin-bottom:0.05rem;margin-top:0.05rem;">
                {{ i.diameter }}
              </p>
              <p class="unit">(mm)</p>
            </div>
            <div class="item_length">
              <p>{{ $t("product.length") }}</p>
              <p style="margin-bottom:0.05rem;margin-top:0.05rem;">(mm)</p>
              <p class="unit">+1/-0</p>
            </div>
            <div class="item_range grip">
              <span>{{ $t("product.grip") }}(mm)</span>
              <img src="@/assets/images/铆接范围.gif" />
              <p class="unit">MIN.-MAX.</p>
            </div>
            <div
              v-if="list.specSwitch.includes('shear')"
              class="item_range shear"
            >
              <span>{{ $t("product.shear") }}(N)</span>
              <img src="@/assets/images/抗剪力.gif" />
              <p class="unit">MIN.</p>
            </div>
            <div
              v-if="list.specSwitch.includes('tensile')"
              class="item_range tensile"
            >
              <span> {{ $t("product.tensile") + "(N)" }}</span>
              <img src="@/assets/images/抗拉力.gif" />
              <p class="unit">MIN.</p>
            </div>
            <div class="item_number">
              <span>{{ $t("product.part") }}</span>
            </div>
            <!-- <div class="item_length">RIVET LENGTH</div>
            <div class="item_range">GRIP RANGE</div>
            <div class="item_number">PART NUMBER</div> -->
            <div class="item_toggle">
              <img src="@/assets/images/icon_plus.png" v-if="i.isClick === 1" />
              <img src="@/assets/images/icon_minus.png" v-else />
            </div>
          </div>
          <div class="table" v-for="sub in i.item" :key="sub.number">
            <div class="table_index"></div>
            <div class="table_length">{{ sub.length }}</div>
            <div class="table_range">{{ sub.range }}</div>
            <div v-if="list.specSwitch.includes('shear')" class="table_range">
              {{ sub.shear }}
            </div>
            <div v-if="list.specSwitch.includes('tensile')" class="table_range">
              {{ sub.tensile }}
            </div>
            <div class="table_number">
              {{ sub.number }}
            </div>
            <div class="table_toggle"></div>
          </div>
        </div>
      </div>
    </u-animate-container>
    <!-- 实际应用 -->
    <u-animate-container
      class="practical_application"
      v-if="list.applicationList"
    >
      <common-title :cn="$t('txt.sjyy')"></common-title>
      <div class="wrap">
        <div class="list">
          <u-animate
            class="item"
            v-for="app in list.applicationList"
            :key="app.desc"
            name="fadeInDown"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <div class="img_wrap">
              <img :src="app.image" />
              <div class="txt">{{ app.desc }}</div>
            </div>
          </u-animate>
        </div>
      </div>
    </u-animate-container>
    <!-- 若您感到兴趣，欢迎与我们联络 -->
    <u-animate-container class="detail_interesting">
      <common-title
        :cn="
          locale === 'zh-cn'
            ? '若您感到兴趣，欢迎与我们联络'
            : 'I AM INTERESTING'
        "
      ></common-title>
      <u-animate
        name="fadeInDown"
        delay="0s"
        duration="1s"
        :iteration="1"
        :offset="0"
        animateClass="animated"
        :begin="false"
      >
        <router-link to="/contact" class="btn_contact">{{
          $t("product.contactus")
        }}</router-link>
      </u-animate>
    </u-animate-container>
    <common-footer :locale="locale"></common-footer>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
import CommonHeader from "./components/Common/Header";
import CommonNav from "./components/Common/OtherNav";
import CommonFooter from "./components/Common/Footer";
import CommonBanner from "./components/Common/Banner";
import CommonTitle from "./components/Common/Title";
export default {
  components: {
    UAnimateContainer,
    UAnimate,
    CommonHeader,
    CommonNav,
    CommonFooter,
    CommonBanner,
    CommonTitle
  },
  created() {
    let _router = this.$route;
    let _id = parseInt(_router.params.id);
    this.id = _router.params.id;
    this.$route.meta.title = `${_router.params.name}-Sailuk`;
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
    this.getData(this.id, this.locale);
  },
  watch: {
    locale(a, b) {
      console.log("locale变化（indexproduct）", a, b);
      this.getData(this.id, this.locale);
    }
  },
  computed: {
    playerOptions() {
      return {
        playbackRates: [1.0, 1.25, 1.5, 2.0, 4.0],
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        sources: [
          {
            type: "",
            src: this.videoSrc
          }
        ],
        poster: "",
        width: "60%",
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true
        }
      };
    }
  },
  data() {
    return {
      list: [],
      isShowExtraDesc: 0,
      isShowFeature: 0,
      isShowMaterial: 0,
      isShowVideo: 0,
      videoSrc: "http://vjs.zencdn.net/v/oceans.mp4",
      locale: "zh-cn"
    };
  },
  methods: {
    getLocale(e) {
      this.locale = e;
    },
    getData(id, lang) {
      let lang2 = lang ? lang : "zh-cn";
      this.$axios
        .post(
          "/api/product/detail",
          {
            productId: id
          },
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.errorCode === 0) {
            this.list = res.data.data;
            // this.isShowExtraDesc = res.data.data.isShowExtraDesc
            this.isShowExtraDesc = 1;
            this.isShowFeature = res.data.data.isShowFeature;
            this.isShowMaterial = res.data.data.isShowMaterial;
            this.isShowVideo = res.data.data.isShowVideo;
            this.videoSrc = res.data.data.video;
          }
        });
    },
    toggleTable(e) {
      console.log(e);
      if (this.list.specList[e]["isClick"] === 1) {
        this.$set(this.list.specList[e], "isClick", 0);
      } else {
        this.$set(this.list.specList[e], "isClick", 1);
      }
      console.log(this.list.specList);
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 1140px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  z-index: 9;
  position: relative;
}
.type_breadcrumb {
  background: #ff8201;
  width: 100%;
  box-sizing: border-box;
  padding: 30px 0;
  margin-top: 130px;
  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .type {
      color: #fff;
      font-size: 0.32rem;
      span {
        font-size: 0.14rem;
        margin-left: 0.15rem;
        position: relative;
        top: 0.03rem;
      }
    }
    .breadcrumb {
      span {
        text-decoration: none;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.5);
        float: left;
        margin-left: 0.2rem;
        transition: all 0.35s;
        cursor: pointer;
        &.on,
        &:hover {
          color: #fff;
        }
      }
    }
  }
}
.title_wrap {
  width: 100%;
  height: 500px;
  position: relative;
  margin: 60px auto;
  .bg_wrap {
    width: 85%;
    background: #f7f7f7;
    height: 100%;
    z-index: 0;
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
  }
  img.bg_title {
    position: absolute;
    left: 35%;
    bottom: -50px;
    width: 280px;
    height: auto;
  }
  img.product {
    float: left;
    margin: 60px 0 0 17%;
  }
  .title {
    float: right;
    width: 380px;
    margin: 130px 120px 0 0;
    .en {
      color: #333;
      font-size: 0.24rem;
      font-weight: bold;
    }
    .cn {
      color: #ff7f00;
      font-size: 0.6rem;
      margin-top: 20px;
      font-weight: bold;
      word-break: break-all;
    }
    .desc {
      color: #5d5d5d;
      font-size: 0.18rem;
      margin-top: 30px;
      line-height: 1.8;
    }
  }
}
.detail_content {
  text-align: center;
  font-size: 0.18rem;
  color: #333;
  line-height: 1.8;
  position: relative;
  height: auto;
  overflow: hidden;
  .container {
    position: relative;
    padding: 30px 0;
    span {
      &.before {
        font-size: 0.35rem;
        color: #ff5e17;
        font-family: "黑体";
        margin-right: 5px;
        font-weight: bold;
      }
      &.after {
        font-size: 0.35rem;
        color: #ff5e17;
        font-family: "黑体";
        margin-left: 5px;
        font-weight: bold;
      }
    }
  }
}
.detail_video {
  margin: 30px auto;
  .video-player {
    width: 800px;
    height: 450px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
.detail_feature {
  padding: 30px 0;
  .container {
    position: relative;
    img {
      width: 450px;
      height: auto;
      float: left;
    }
    .content {
      width: 600px;
      box-sizing: border-box;
      margin-left: 20px;
      font-size: 0.18rem;
      line-height: 1.8;
      float: left;
      padding-top: 20px;
      p {
        position: relative;
        &::before {
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 50%;
          position: absolute;
          left: -20px;
          top: 0.13rem;
          background: #ff7f00;
        }
      }
    }
  }
}
.detail_material {
  padding: 30px 0;
  .container {
    background: #f7f7f7;
    padding: 30px 0;
    overflow: hidden;
    .head {
      width: 700px;
      margin-left: auto;
      margin-right: auto;
      overflow: hidden;
      margin-bottom: 15px;
      .img_head {
        width: 60px;
        float: left;
        height: 40px;
        background: none;
        margin-right: 10px;
      }
      .title_head {
        background: #ff5e16;
        color: #fff;
        font-size: 0.18rem;
        width: 280px;
        text-align: center;
        height: 40px;
        line-height: 40px;
        float: left;
        margin-left: 10px;
        margin-right: 10px;
        span {
          font-size: 0.14rem;
          margin-left: 10px;
        }
      }
    }
    .item {
      width: 700px;
      margin-left: auto;
      margin-right: auto;
      overflow: hidden;
      height: 110px;
      display: flex;
      display: -ms-flexbox;
      align-items: center;
      border-bottom: 1px solid #ccc;
      &:last-child {
        border-bottom: 0;
      }
      .img_item {
        width: 60px;
        float: left;
        background: none;
        display: flex;
        display: -ms-flexbox;
        margin-right: 10px;
        img {
          width: 60px;
          height: 60px;
          margin-left: auto;
          margin-right: auto;
          display: block;
        }
      }
      .title_item {
        background: none;
        color: #333;
        font-size: 0.18rem;
        width: 280px;
        height: 110px;
        float: left;
        display: flex;
        display: -ms-flexbox;
        flex-direction: column;
        -ms-flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        margin-right: 10px;
        &:last-child {
          border-left: 1px solid #ccc;
          margin-left: 0;
        }
        p {
          font-size: 0.18rem;
          line-height: 1.6;
        }
      }
    }
  }
}
.detail_table {
  padding: 30px 0;
  img.top {
    width: 500px;
    display: block;
    margin: 0 auto;
    margin-bottom: 45px;
  }
  .table_item {
    margin-bottom: 20px;
    .item {
      background: #ff5e17;
      color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      font-size: 0.2rem;
      box-sizing: border-box;
      height: 100px;
      .item_index {
        background: #e04402;
        width: 80px;
        height: 100px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        display: flex;
      }
      .item_length,
      .item_range,
      .item_number {
        height: 100px;
        flex-direction: row;
        box-sizing: border-box;
        display: flex;
        background: inherit;
        color: inherit;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        &.item_length,
        &.item_range {
          width: 350px;
        }
        &.item_number {
          width: 280px;
        }
        &.shear,
        &.tensile,
        &.grip {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          img {
            width: 40%;
            max-width: 50px;
            height: auto;
          }
        }
      }
      .item_toggle {
        width: 80px;
        height: 100px;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        display: flex;
        img {
          display: flex;
          width: 30px;
          height: 30px;
        }
      }

      .unit {
        font-size: 0.18rem;
      }
    }
    .table {
      background: none;
      color: #333;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 0.2rem;
      height: 60px;
      box-sizing: border-box;
      .table_toggle,
      .table_index {
        width: 80px;
        height: 80px;
      }
      .table_length,
      .table_range,
      .table_number {
        height: 60px;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        box-sizing: border-box;
        display: flex;
        border-bottom: 1px solid #eee;
        &.table_length,
        &.table_range {
          width: 350px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
        &.table_number {
          width: 280px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }
      }
      &:last-child {
        .table_length,
        .table_range,
        .table_number {
          border-bottom: 0;
        }
      }
    }
    &.on {
      .item {
        background: #cbcecd;
        .item_index {
          background: #57605d;
        }
      }
      .table {
        display: none;
      }
    }
  }
}
.practical_application {
  padding: 30px 0;
  .wrap {
    height: auto;
    overflow: hidden;
    .list {
      display: flex;
      display: -ms-flexbox;
      -ms-flex-direction: row;
      flex-direction: row;
      width: 1140px;
      height: auto;
      // overflow: hidden;
      margin: 0rem auto;
      position: relative;
      .item {
        width: 23%;
        display: flex;
        display: -ms-flexbox;
        float: left;
        height: auto;
        margin-right: 2.5%;
        flex-direction: column;
        -ms-flex-direction: column;
        // overflow: hidden;
        &:last-child {
          margin-right: 0;
        }
        .img_wrap {
          width: 100%;
          height: 270px;
          box-sizing: border-box;
          background: url("../assets/images/border_img_solution.png") no-repeat
            center center;
          background-size: 100% 100%;
          color: #f2f0ee;
          position: relative;
          display: flex;
          display: -ms-flexbox;
          justify-content: center;
          align-items: center;
          padding: 15px;
          img {
            width: 100%;
            height: 100%;
            display: flex;
            display: -ms-flexbox;
          }
          .txt {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            font-size: 0.25rem;
            height: 0.3rem;
          }
        }
      }
    }
  }
}
.detail_interesting {
  padding: 30px 0 60px 0;
  .btn_contact {
    border: 4px solid #ff7f00;
    color: #ff7f00;
    width: 160px;
    height: 50px;
    line-height: 50px;
    border-radius: 50px;
    font-size: 0.18rem;
    text-align: center;
    text-decoration: none;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}
@media screen and (max-width: 750px) {
  .container {
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
  }
  .type_breadcrumb {
    margin-top: 60px;
    background: none;
    padding: 0;
    position: relative;
    z-index: 0;
    display: none;
    .container {
      padding: 0;
      .type {
        font-size: 0.9rem;
        width: 100%;
        height: 60px;
        line-height: 60px;
        background: #ff7f00;
        box-sizing: border-box;
        padding: 0 15px;
        span {
          margin-left: 1.5rem;
          font-size: 0.6rem;
        }
      }
      .breadcrumb {
        display: none;
      }
    }
  }
  .title_wrap {
    margin: 0;
    margin-top: 60px;
    height: auto;
    overflow: hidden;
    position: relative;
    z-index: 0;
    height: auto;
    .bg_wrap {
      width: 100%;
      height: 300px;
    }
    img.bg_title {
      width: 40%;
      height: auto;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .container {
      display: flex;
      flex-direction: column-reverse;
      img.product {
        margin: auto;
        width: auto;
        height: 280px;
        display: block;
        float: none;
      }
      .title {
        width: 100%;
        box-sizing: border-box;
        margin: 30px auto 30px;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        justify-content: center;
        .en {
          font-size: 0.8rem;
          margin-top: 0.6rem;
        }
        .cn {
          font-size: 1.2rem;
          margin-top: 0;
        }
        .desc {
          display: none;
        }
      }
    }
  }
  .detail_content {
    padding: 0;
    height: auto;
    overflow: auto;
    z-index: 0;
    .container {
      padding: 0 15px;
      font-size: 0.8rem;
      color: #5d5d5d;
      height: auto;
      p {
        margin: 0;
      }
      img {
        display: none;
      }
      span {
        position: relative;
        top: initial;
        left: initial;
        display: block;
        width: 100%;
        padding: 0 30px;
        line-height: 1.5;
        box-sizing: border-box;
        word-break: break-all;
        transform: translate(0, 0);
        text-align: left;
      }
      span.before {
        font-size: 2rem;
        font-family: "黑体";
        color: #ff7f00;
        position: absolute;
        left: -1.5rem;
        display: inline;
        top: -0.5rem;
        width: auto;
      }
      span.after {
        font-size: 2rem;
        font-family: "黑体";
        color: #ff7f00;
        position: absolute;
        right: -1.5rem;
        display: inline;
        bottom: -1.8rem;
        width: auto;
      }
    }
  }
  .detail_video {
    margin: 15px auto;
    .video-player {
      width: 100%;
      height: 250px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .detail_feature {
    position: relative;
    z-index: 0;
    padding: 15px 0;
    .container {
      img {
        width: 100%;
      }
      .content {
        width: 100%;
        margin: 0;
        padding: 0;
        font-size: 0.6rem;
        p {
          &::before {
            display: none;
          }
        }
      }
    }
  }
  .detail_material {
    padding: 15px 0;
    position: relative;
    z-index: 0;
    .container {
      padding: 15px;
      .head {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-bottom: 0;
        .img_head {
          display: flex;
          min-width: 35px;
          margin-right: 0;
        }
        .title_head {
          display: flex;
          flex: 1;
          justify-content: center;
          font-size: 0.8rem;
          span {
            margin-left: 5px;
          }
        }
      }
      .item {
        width: 100%;
        display: flex;
        height: 100px;
        flex-direction: row;
        justify-content: center;
        box-sizing: border-box;
        .img_item {
          min-width: 35px;
          img {
            width: 32px;
            height: auto;
          }
        }
        .title_item {
          height: 100px;
          margin: 0;
          display: flex;
          flex: 1;
          &:last-child {
            border: 0;
          }
          p {
            font-size: 0.8rem;
          }
        }
      }
    }
  }
  .detail_table {
    padding: 15px 0;
    img.top {
      width: 80%;
      margin-bottom: 20px;
    }
    .table_item {
      margin-bottom: 10px;
      overflow-x: auto;
      .item {
        height: 70px;
        font-size: 0.8rem;
        width: auto;
        font-size: 12px !important;
        .item_index {
          height: 70px;
          min-width: 40px;
          display: flex;
          font-size: 12px !important;
          p,
          span {
            font-size: 12px !important;
            display: inline-block;
            transform: scale(0.7);
            white-space: nowrap;
          }
        }
        .item_length,
        .item_range,
        .item_number {
          height: 70px;
          display: flex;
          width: auto;
          p,
          span {
            font-size: 12px !important;
            display: inline-block;
            transform: scale(0.7);
            white-space: nowrap;
          }
        }
        .item_toggle {
          min-width: 40px;
          height: 70px;
          display: flex;
          background-color: inherit;
          color: inherit;
          img {
            width: 20px;
            height: 20px;
          }
        }
        .unit {
          transform: scale(0.7);
        }
      }
      .table {
        height: 40px;
        margin-left: -10px;
        transition: all 0.35s;
        font-size: 0.8rem;
        font-size: 12px;
        .table_index,
        .table_toggle {
          height: 40px;
          min-width: 40px;
          display: flex;
        }
        .table_length,
        .table_range,
        .table_number {
          height: 40px;
          display: flex;
          min-width: 40px;
          width: auto;
          transform: scale(0.7);
          white-space: nowrap;
        }
      }
    }
  }
  .practical_application {
    padding: 15px 0;
    .wrap {
      .list {
        width: 100%;
        box-sizing: border-box;
        padding: 0 15px;
        flex-wrap: wrap;
        .item {
          width: 48%;
          margin-bottom: 0.8rem;
          .img_wrap {
            height: 160px;
            .txt {
              height: 1rem;
              font-size: 0.7rem;
            }
          }
        }
      }
    }
  }
  .detail_interesting {
    padding: 15px 0 60px 0;
    .btn_contact {
      font-size: 0.8rem;
      height: 2rem;
      line-height: 2rem;
      width: 7rem;
      border-width: 0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ProductDetail.vue